// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import issueAffectedArticleEntity from './entities/issue-affected-article.json';
import issueAffectedArticleMenu from '../pages/issue-affected-article/menu.json';
import issueAffectedArticleFullForm from '../pages/issue-affected-article/forms/full.json';
import issueAffectedArticleContextForm from '../pages/issue-affected-article/forms/context.json';
import issueAffectedArticleMiniForm from '../pages/issue-affected-article/forms/mini.json';
import issueAffectedArticleLookupForm from '../pages/issue-affected-article/forms/lookup.json';
import issueAffectedArticleTableView from '../pages/issue-affected-article/views/table.json';
import issueAffectedArticleCardsView from '../pages/issue-affected-article/views/cards.json';
import issueAffectedArticleDashboardView from '../pages/issue-affected-article/views/dashboard.json';

/** Тип запису «Зачеплена стаття» зі сторінками пакета: меню, форми та подання з pages/issue-affected-article/. */
export const issueAffectedArticleDefinition: IRecordTypeDefinition = {
  ...issueAffectedArticleEntity,
  views: assembleViewSet({
      table: issueAffectedArticleTableView,
      cards: issueAffectedArticleCardsView,
      dashboard: issueAffectedArticleDashboardView,
  }),
  form: issueAffectedArticleFullForm,
  forms: { full: issueAffectedArticleFullForm, context: issueAffectedArticleContextForm, mini: issueAffectedArticleMiniForm, lookup: issueAffectedArticleLookupForm },
  menu: issueAffectedArticleMenu,
} as IRecordTypeDefinition;
